import { render } from "./MilitaryStudentsView.vue?vue&type=template&id=1beb4e3e&scoped=true"
import script from "./MilitaryStudentsView.vue?vue&type=script&lang=js"
export * from "./MilitaryStudentsView.vue?vue&type=script&lang=js"

import "./MilitaryStudentsView.vue?vue&type=style&index=0&id=1beb4e3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1beb4e3e"]])

export default __exports__